export const keywordsData = [
  {
    name: "Afflict",
    exampleCard: "Wildfire Eternal",
    description: "Whenever a creature with afflict becomes blocked, the defending player loses a specified amount of life.",
    notes: "This mechanic is excellent for aggressive decks that want to guarantee life loss even when the opponent has blockers. Since it causes life loss rather than damage, it cannot be prevented by traditional damage-prevention effects."
  },
  {
    name: "Airbend",
    exampleCard: "Wildfire Eternal",
    description: "As long as that card remains exiled, its owner may cast it by paying {2} rather than paying its mana cost. This doesn't change when that card can be cast.",
    notes: "This mechanic is excellent with blinking decks"
  },
  {
  name: "Adamant",
  exampleCard: "Slaying Fire",
  description: "Spells with adamant have additional or alternative effects if at least three mana of a specific color (or type) was spent to cast them.",
  notes: "Adamant checks the actual mana spent. If you cast a spell without paying its mana cost, or if you copy the spell, the adamant ability will not trigger because no mana was spent."
  },
  {
    name: "Deathtouch",
    exampleCard: "Sedge Scorpion",
    description: "Whenever a creature with deathtouch deals damage to another creature, that creature will die. This applies to any damage, not just combat damage.",
    notes: "If you use a spell like Rabid Bite with a deathtouch creature, it will kill the target. Note that normal deathtouch doesn't affect planeswalkers unless specified (e.g., Vraska, Swarm's Eminence)."
  },
  {
    name: "Defender",
    exampleCard: "Wall of Mist",
    description: "A creature with defender cannot attack.",
    notes: "Historically, the rule was 'Walls can't attack.' Even if an old card with the 'Wall' type doesn't have the defender keyword printed, it still functionally has defender."
  },
  {
    name: "Double Strike",
    exampleCard: "Boros Swiftblade",
    description: "A creature with double strike deals combat damage twice: once during the first-strike damage step and once during the regular damage step.",
    notes: ""
  },
  {
    name: "Enchant",
    exampleCard: "Abundant Growth",
    description: "Written as 'Enchant X' (where X is a permanent type), these cards are Auras that must target a specific permanent when cast.",
    notes: "If the target is removed before the Aura resolves, it goes to the graveyard. However, if an Aura enters from the graveyard directly, you choose a target without 'targeting', which can sometimes bypass Hexproof."
  },
  {
    name: "Equip",
    exampleCard: "Sword of Feast and Famine",
    description: "Written as 'Equip X' (where X is a mana cost). Equipment enters the battlefield and can be attached to a creature by paying this cost.",
    notes: "Equipment can only be moved to another creature, not simply 'unattached.' Unless stated otherwise, you can only activate the equip ability at sorcery speed."
  },
  {
    name: "First Strike",
    exampleCard: "Battle Hurda",
    description: "Creatures with first strike deal damage before creatures without it during the combat phase.",
    notes: "Example: If a 2/2 with first strike battles a regular 2/2, the first striker deals damage first and kills the other creature before it can hit back."
  },
  {
    name: "Flash",
    exampleCard: "Bounding Krasis",
    description: "Found on nonland cards, Flash allows you to cast the spell at any time you could cast an instant.",
    notes: "This applies to creatures, artifacts, enchantments, and even planeswalkers, allowing for powerful surprise plays during your opponent's turn."
  },
  {
    name: "Flying",
    exampleCard: "Storm Crow",
    description: "Creatures with flying can only be blocked by other creatures with flying or by creatures with reach.",
    notes: ""
  },
  {
    name: "Haste",
    exampleCard: "Tenement Crasher",
    description: "Creatures with haste ignore 'summoning sickness.' They can attack or use abilities that require tapping the same turn they enter the battlefield.",
    notes: ""
  },
  {
    name: "Lifelink",
    exampleCard: "Bishop’s Soldier",
    description: "Damage dealt by a creature with lifelink also causes its controller to gain that much life.",
    notes: "Lifelink is not a triggered ability; the life gain happens simultaneously with the damage. This means if you are dealt lethal damage but a lifelink blocker brings you back above 0 in the same moment, you survive. This differs from older triggered abilities (like 'Spirit Link') which use the stack."
  },
  {
    name: "Menace",
    exampleCard: "Ruin Grinder",
    description: "A creature with menace cannot be blocked except by two or more creatures.",
    notes: "Menace is particularly potent when paired with Deathtouch, as it makes blocking mathematically unfavorable for the opponent."
  },
  {
    name: "Protection",
    exampleCard: "Apostle of Purifying Light",
    description: "Written as 'Protection from [quality]'. A creature with protection cannot be Damaged, Enchanted/Equipped, Blocked, or Targeted (D.E.B.T.) by sources of that quality.",
    notes: "Protection is deep: 1) It prevents damage, but if an effect says 'damage cannot be prevented,' the protection creature still takes damage. 2) It doesn't stop board wipes like 'Destroy all creatures' because they don't target. 3) It includes your own things; a white aura will fall off a creature that gains protection from white."
  },
  {
    name: "Prowess",
    exampleCard: "Monastery Swiftspear",
    description: "Whenever you cast a noncreature spell, this creature gets +1/+1 until end of turn.",
    notes: "Prowess triggers stack. If you cast two noncreature spells in the same turn, the creature will get a total of +2/+2."
  },
  {
    name: "Reach",
    exampleCard: "Giant Spider",
    description: "This creature can block creatures with flying.",
    notes: "Reach does not grant flying; the creature stays on the ground but can 'reach' up to intercept aerial attackers."
  },
  {
    name: "Trample",
    exampleCard: "Colossal Dreadmaw",
    description: "Creatures with trample can deal excess combat damage to the defending player or planeswalker after assigning lethal damage to all blockers.",
    notes: "Example: A 6/6 with trample blocked by a 3/3 still deals 3 damage to the player. Strategic Tip: If a creature has both Deathtouch and Trample, it only needs to assign 1 damage to the blocker (lethal) and the rest goes to the player."
  },
  {
    name: "Vigilance",
    exampleCard: "Serra Angel",
    description: "Attacking does not cause this creature to tap.",
    notes: "This allows the creature to stay upright and available to block during the opponent's next turn."
  },
  {
    name: "Ward",
    exampleCard: "Dreadlight Monstrosity",
    description: "Written as 'Ward [cost]'. If this creature is targeted by a spell or ability an opponent controls, counter it unless that opponent pays the ward cost.",
    notes: "Ward is a 'fixed' version of Hexproof; it allows interaction but makes it taxing for the opponent."
  },
  {
    name: "Attach",
    exampleCard: "Darksteel Garrison",
    description: "The action of 'putting on' an Aura, Equipment, or Fortification onto a permanent.",
    notes: "While common on Auras and Equipment, Fortifications are a rare subtype (only Darksteel Garrison exists)."
  },
  {
    name: "Clash",
    exampleCard: "Fire Juggler",
    description: "Each clashing player reveals the top card of their library. The player with the higher mana value wins. In a tie, there is no winner.",
    notes: "After clashing, players choose to put the revealed card back on top or on the bottom of their library."
  },
  {
    name: "Counter",
    exampleCard: "Counterspell",
    description: "To cancel a spell or ability so that it does not resolve. Countered spells are removed from the stack and put into their owner's graveyard.",
    notes: "Often referred to as 'Permission' spells, as they allow you to say 'no' to your opponent's plays."
  },
  {
    name: "Reconfigure",
    exampleCard: "The Reality Chip",
    description: "Written as 'Reconfigure [cost]'. These are artifact creatures that can be attached to a creature as Equipment or unattached to become a creature again.",
    notes: "Unlike standard Equipment, Reconfigure can be used to unattach the card. It follows sorcery-speed timing."
  },
  {
    name: "Regeneration",
    exampleCard: "Ancient Silverback",
    description: "Written as 'Regenerate [cost]'. Paying the cost creates a 'regeneration shield'. If the permanent would be destroyed this turn, it is instead tapped and removed from combat.",
    notes: "This is a replacement effect. You replace destruction with tapping and survival. Note: Regeneration does not stop 'sacrifice' or -X/-X effects."
  },
  {
    name: "Sacrifice",
    exampleCard: "Chainer’s Edict",
    description: "To move a permanent you control to your graveyard. You cannot sacrifice something you don't control.",
    notes: "Sacrifice is different from 'destruction'—it bypasses Indestructible and Regeneration. It can be part of a spell's cost or an effect forced by an opponent."
  },
  {
    name: "Scry",
    exampleCard: "Crystal Ball",
    description: "Written as 'Scry X'. Look at the top X cards of your library. You may put any number of them on the bottom of your library and the rest on top in any order.",
    notes: "An essential mechanic for smoothing out your draws and finding specific answers."
  },
  {
    name: "Tap/Untap",
    exampleCard: "",
    description: "To turn a card sideways (Tap) to use its abilities or attack, or to return it to the upright position (Untap).",
    notes: ""
  },
  {
    name: "Absorb",
    exampleCard: "Lymph Sliver",
    description: "Written as 'Absorb X'. If a source would deal damage to this creature, prevent X of that damage.",
    notes: "Example: If a creature with Absorb 1 is hit by a Lightning Bolt (3 damage), it only takes 2 damage."
  },
  {
    name: "Adapt",
    exampleCard: "Growth-Chamber Guardian",
    description: "Written as '[cost]: Adapt X'. If this creature has no +1/+1 counters on it, put X +1/+1 counters on it.",
    notes: "Commonly seen in Simic (Green/Blue) decks, often triggering additional effects when counters are placed."
  },
  {
    name: "Adventure",
    exampleCard: "Bonecrusher Giant",
    description: "A card with Adventure can be cast as an Instant or Sorcery (the Adventure) and exiled. You may then cast the creature half from exile.",
    notes: "You cannot cast the Adventure part if the creature is already on the battlefield. All Adventures are non-permanent spells."
  },
  {
    name: "Affinity",
    exampleCard: "Thoughtcast",
    description: "Written as 'Affinity for X'. This spell costs {1} less to cast for each permanent you control of type X.",
    notes: "Most commonly 'Affinity for Artifacts'. It only reduces generic mana. For example, if you have 4 artifacts, Frogmite ({4}) becomes free, but Thoughtcast ({4}{U}) still requires at least {U} to be cast."
  },
  {
    name: "Afterlife",
    exampleCard: "Orzhov Enforcer",
    description: "Written as 'Afterlife X'. When this creature dies, create X 1/1 white and black Spirit creature tokens with flying.",
    notes: "A great way to maintain board presence after a trade or a board wipe."
  },
  {
    name: "Aftermath",
    exampleCard: "Commit // Memory",
    description: "Found on split cards. One half can be cast from your hand, while the other half (with Aftermath) can only be cast from your graveyard.",
    notes: "Once the Aftermath half is cast, the card is exiled."
  },
  {
    name: "Alliance",
    exampleCard: "Gala Greeters",
    description: "An ability word that triggers whenever another creature enters the battlefield under your control.",
    notes: "Think of it as 'Landfall' but specifically for creatures entering the fray."
  },
  {
  name: "Amass",
  exampleCard: "Enter the God-Eternals",
  description: "To 'Amass [subtype] X', put X +1/+1 counters on an Army you control. If you don't control one, create a 0/0 [subtype] Army token first. If the Army isn't already that subtype, it becomes that subtype in addition to its other types.",
  notes: "This mechanic is designed to build a single, powerful 'tall' creature rather than a wide board. It is written as 'Amass [creature type] X'. If you already have an Army token of a different type (e.g., an Orc Army) and you Amass Zombies, your existing Army will gain the counters and become both an Orc and a Zombie."
  },
  {
    name: "Amplify",
    exampleCard: "Kilnmouth Dragon",
    description: "Written as 'Amplify X'. As this creature enters the battlefield, you may reveal any number of cards from your hand that share a creature type with it.",
    notes: "The creature enters with X +1/+1 counters for each card revealed this way. For example, revealing 2 Dragons for a creature with Amplify 3 results in 6 counters."
  },
  {
    name: "Annihilator",
    exampleCard: "Ulamog’s Crusher",
    description: "Written as 'Annihilator X'. Whenever this creature attacks, the defending player must sacrifice X permanents.",
    notes: "This is a signature ability of the Eldrazi. The sacrifice happens as soon as the creature is declared as an attacker, before blockers are even chosen."
  },
  {
  name: "Ascend",
  exampleCard: "Andúril, Narsil Reforged",
  description: "If you control ten or more permanents, you get the city’s blessing for the rest of the game.",
  notes: "Once you have the city's blessing, you keep it for the rest of the game even if your permanent count drops below ten. Normally, this keyword provides a significant advantage to the card itself or to other cards you control that share the keyword once the blessing is obtained."
  },
  {
    name: "Aura Swap",
    exampleCard: "Arcanum Wings",
    description: "Written as 'Aura Swap [cost]'. You may pay the cost to exchange this Aura with an Aura card in your hand.",
    notes: "This is a powerful way to 'cheat' expensive Auras like Eldrazi Conscription onto a creature at instant speed. Currently only found on the card Arcanum Wings."
  },
  {
  name: "Awaken",
  exampleCard: "Ruinous Path",
  description: "You may pay a spell's awaken cost rather than its mana cost. If you do, also put X +1/+1 counters on target land you control and it becomes a 0/0 Elemental creature with haste. It’s still a land.",
  notes: "Awaken turns a utility spell into a late-game win condition by creating a creature. Because the land remains a land, it can still be tapped for mana, but it also becomes susceptible to creature removal. If the spell is countered or its original targets become illegal, the awaken effect will not happen."
  },
  {
    name: "Banding",
    exampleCard: "Knights of Thorn",
    description: "A keyword that allows creatures to attack or block as a group ('band').",
    notes: "Historically the most complex mechanic in MTG. Its main benefit is that the controller of the 'band' decides how combat damage is distributed among their creatures, rather than the opponent choosing. It is now a retired mechanic."
  },
  {
  name: "Backup",
  exampleCard: "Conclave Sledge-Captain",
  description: "Writte as 'Backup X'. When this creature enters the battlefield, put a +1/+1 counter on target creature. If that’s another creature, it gains the following abilities until end of turn. Each backup ability triggers separately.",
  notes: "This mechanic is incredibly powerful because it can distribute multiple counters and abilities across your board. With cards like Conclave Sledge-Captain, you can choose to put all three backup triggers on the same creature to triple its effectiveness, or spread them among different creatures to maximize your tactical options for the turn."
  },
  {
  name: "Bargain",
  exampleCard: "Beseech the Mirror",
  description: "Bargain is an optional additional cost. As you cast a spell, you may sacrifice an artifact, enchantment, or token.",
  notes: "This mechanic is a 'fixed' version of Kicker that rewards you for trading away resources like Treasure tokens, Food, or unwanted enchantments. If a spell is 'Bargained,' it gains a more powerful effect. Note that you can only sacrifice one permanent to satisfy the bargain cost of a single spell."
  },
  {
    name: "Battle Cry",
    exampleCard: "Signal Pest",
    description: "Whenever this creature attacks, each other attacking creature gets +1/+0 until end of turn.",
    notes: "Perfect for 'Go-Wide' strategies where you attack with a large number of small creatures."
  },
  {
  name: "Behold",
  exampleCard: "Champion of the Weird",
  description: "To behold a creature, you must exile a creature you control or a creature card from your hand.",
  notes: "Behold acts as a specific requirement to unlock or enhance abilities. Normally, this keyword provides a significant advantage by rewarding you for 'curating' your collection, often triggering powerful bonuses or effects on cards like Champion of the Weird once the condition is met."
  },
  {
    name: "Bestow",
    exampleCard: "Celestial Archon",
    description: "Written as 'Bestow [cost]'. You may cast this card as an Aura attached to a creature. If the enchanted creature leaves the battlefield, the Bestow card stays as a creature.",
    notes: "This provides excellent protection against '2-for-1' trades, as you don't lose your permanent if the target dies."
  },
  {
  name: "Blight",
  exampleCard: "Auntie Ool, Cursewretch",
  description: "To blight X, a player puts X -1/-1 counters on a creature they control.",
  notes: "This keyword is a powerful tool for imposing board control. Normally, this keyword provides a significant advantage by forcing an opponent to weaken their own creatures or by triggering beneficial effects for you when a creature is blighted. It is particularly effective for bypassing defenses, as it guarantees a permanent debuff regardless of combat."
  },
  {
    name: "Blitz",
    exampleCard: "Tenacious Underdog",
    description: "Written as 'Blitz [cost]'. You may cast the spell for its blitz cost. It gains haste and 'When this creature dies, draw a card.' Sacrifice it at the beginning of the next end step.",
    notes: "Blitz is a sorcery-speed action. It's ideal for aggressive decks that need to maintain card draw momentum."
  },
  {
    name: "Bloodrush",
    exampleCard: "Skarrg Goliath",
    description: "Written as 'Bloodrush [cost]'. You may pay the cost and discard this card to give a target attacking creature a power/toughness boost and abilities.",
    notes: "Because this is an activated ability and not a spell, it is much harder for opponents to counter it using traditional Counterspells."
  },
  {
    name: "Bloodthirst",
    exampleCard: "Scab-Clan Mauler",
    description: "Written as 'Bloodthirst X'. If an opponent was dealt damage this turn, this creature enters the battlefield with X +1/+1 counters.",
    notes: "Example: If you deal damage with a turn 1 creature and then play Scab-Clan Mauler on turn 2, it enters as a 3/3. Without prior damage, it's just a 1/1."
  },
  {
  name: "Boast",
  exampleCard: " Axgard Braggart",
  description: "An activated ability that can be used only if the creature attacked this turn, and only once each turn.",
  notes: "This keyword provides a significant advantage by rewarding aggressive play with extra utility or buffs. It can be activated during combat (after the creature is declared as an attacker) or during the post-combat main phase, making it a flexible way to press an advantage even if the opponent has blockers."
  },
  {
    name: "Bolster",
    exampleCard: "Dromoka, the Eternal",
    description: "Written as 'Bolster X'. To bolster, choose a creature you control with the least toughness and put X +1/+1 counters on it.",
    notes: "If there's a tie for the least toughness, you choose which one of those creatures gets the counters."
  },
  {
    name: "Bushido",
    exampleCard: "Devoted Retainer",
    description: "Written as 'Bushido X'. When this creature blocks or becomes blocked, it gets +X/+X until end of turn.",
    notes: "A signature mechanic of the Samurai from the 2004 Kamigawa block. It makes these creatures much more formidable in combat than their base stats suggest."
  },
  {
    name: "Buyback",
    exampleCard: "Capsize",
    description: "Written as 'Buyback [cost]'. You may pay the extra buyback cost as you cast the spell. If you do, the spell goes back to your hand upon resolution instead of the graveyard.",
    notes: "A powerful engine for late-game advantage. In some combos, generating infinite mana allows you to cast Buyback spells like Capsize infinitely to clear the opponent's board."
  },
  {
    name: "Cascade",
    exampleCard: "Bloodbraid Elf",
    description: "When you cast this spell, exile cards from the top of your library until you exile a nonland card with a lower mana value. You may cast it without paying its mana cost.",
    notes: "Cascade is widely considered one of the most powerful mechanics in Magic, as it essentially provides two spells for the price of one and thins your deck."
  },
  {
    name: "Casualty",
    exampleCard: "A Little Chat",
    description: "Written as 'Casualty X'. As you cast this spell, you may sacrifice a creature with power X or greater. If you do, copy the spell.",
    notes: "Introduced in Streets of New Capenna, this mechanic allows you to turn your smaller or expendable creatures into extra value."
  },
  {
    name: "Champion",
    exampleCard: "Wanderwine Prophets",
    description: "Written as 'Champion a [type]'. When this enters, you must exile another permanent of the specified type you control or sacrifice this. When this leaves, the exiled card returns.",
    notes: "It's an 'evolution-style' mechanic that protects a creature underneath it, bringing it back if the Champion is removed."
  },
  {
    name: "Changeling",
    exampleCard: "Chameleon Colossus",
    description: "A creature with changeling has every creature type at all times.",
    notes: "Essential for 'Tribal' or 'Kindred' decks, as changelings benefit from every specific type bonus (like Elf, Dragon, or Sliver) simultaneously."
  },
  {
    name: "Channel",
    exampleCard: "Greater Tanuki",
    description: "Written as 'Channel [cost]'. You may discard the card for the specified cost to get a unique effect.",
    notes: "Because Channel is an activated ability and not a spell, it's much harder to counter with traditional 'Counterspell' cards."
  },
  {
    name: "Cipher",
    exampleCard: "Call of the Nightwing",
    description: "As this spell resolves, you may exile it encoded on a creature you control. Whenever that creature deals combat damage to a player, you may cast a copy of the encoded spell for free.",
    notes: "While it sounds strong, it's often hard to pull off because the spells are expensive and the creatures need to survive to deal damage."
  },
  {
    name: "Connive",
    exampleCard: "Ledger Shredder",
    description: "To connive, a creature's controller draws a card, then discards a card. If a nonland card was discarded, the creature gets a +1/+1 counter.",
    notes: "Some cards specify 'Connive X', allowing you to draw and discard X cards. It's a great way to filter your hand while buffing your creatures."
  },
  {
    name: "Clash",
    exampleCard: "Research the Deep",
    description: "Each clashing player reveals the top card of their library, then puts that card on the top or bottom. A player wins if their card had a higher mana value.",
    notes: "See tis mechaninc aa a strange Scry1"
  },
  {
    name: "Conspire",
    exampleCard: "Giantbaiting",
    description: "As you cast this spell, you may tap two untapped creatures you control that share a color with it. If you do, copy the spell.",
    notes: "A great way for creature-heavy decks to get double value out of their instants and sorceries."
  },
  {
    name: "Convoke",
    exampleCard: "March of the Multitudes",
    description: "Your creatures can help pay for this spell. Each creature you tap while casting this spell pays for {1} or one mana of that creature's color.",
    notes: "Example: If you have 5 creatures and 4 lands, you can cast a spell with mana value 9. It's a staple mechanic for Selesnya (Green/White) go-wide decks."
  },
  {
    name: "Coven",
    exampleCard: "Augur of Autumn",
    description: "An ability word that grants benefits if you control three or more creatures with different powers.",
    notes: "Introduced in Midnight Hunt, it rewards decks that play a variety of creatures rather than just tokens of the same size."
  },
  {
    name: "Crew",
    exampleCard: "Aethersphere Harvester",
    description: "Written as 'Crew X'. To turn a Vehicle into an artifact creature until end of turn, tap any number of creatures you control with total power X or greater.",
    notes: "Example: Aethersphere Harvester needs only 1 power to crew, while a card like Colossal Plow requires 6 power to become a creature."
  },
  {
    name: "Cumulative Upkeep",
    exampleCard: "Mystic Remora",
    description: "Written as 'Cumulative Upkeep [cost]'. At the beginning of your upkeep, put an age counter on this permanent, then pay the upkeep cost for each age counter on it or sacrifice it.",
    notes: "A compounding cost: if the upkeep is {1}, you pay {1} on turn two, {2} on turn three, {3} on turn four, and so on. It makes cards difficult to keep on the battlefield for long periods."
  },
  {
    name: "Cycling",
    exampleCard: "Cast Out",
    description: "Written as 'Cycling [cost]'. You may pay the cost and discard the card to draw a new card.",
    notes: "Extremely versatile for cards that are situational. Variations like 'Basic Landcycling' allow you to search for a basic land instead of drawing a random card, which is a staple for budget multi-color decks."
  },
  {
    name: "Dash",
    exampleCard: "Ragavan, Nimble Pilferer",
    description: "Written as 'Dash [cost]'. You may cast the creature for its dash cost. It gains haste and is returned to its owner's hand at the beginning of the next end step.",
    notes: "Dash is a great way to dodge 'Sorcery-speed' removal like board wipes, as the creature is only on the battlefield during your turn."
  },
  {
    name: "Daybound / Nightbound",
    exampleCard: "Brutal Cathar",
    description: "A mechanic that tracks the Day/Night cycle. If a player casts no spells during their own turn, it becomes Night next turn. If a player casts two or more spells during their own turn, it becomes Day next turn.",
    notes: "Cards with these keywords transform based on whether it is Day or Night, often becoming significantly stronger at Night."
  },
  {
    name: "Delve",
    exampleCard: "Treasure Cruise",
    description: "Each card you exile from your graveyard while casting this spell pays for {1}.",
    notes: "Considered one of the most 'broken' mechanics. It allows you to cast high-mana spells like Treasure Cruise for as little as one mana by using your graveyard as a resource."
  },
  {
    name: "Descend",
    exampleCard: "The Mycotyrant",
    description: "Checks if a permanent card is put into your graveyard from anywhere, or counts the number of permanent cards in your graveyard.",
    notes: "A highly synergistic mechanic for graveyard-focused decks. It rewards you for self-milling, discarding, or sacrificing permanents, turning your graveyard into a passive value engine."
  },
  {
    name: "Detain",
    exampleCard: "Lavinia of the Tenth",
    description: "Until your next turn, a detained permanent cannot attack or block, and its activated abilities cannot be activated.",
    notes: "A defensive mechanic primarily found in the Azorius (Blue/White) guild."
  },
  {
    name: "Devour",
    exampleCard: "Predator Dragon",
    description: "Written as 'Devour X'. As this enters the battlefield, you may sacrifice any number of creatures. This creature enters with X +1/+1 counters for each sacrificed creature.",
    notes: "A 'sacrifice' mechanic that turns a wide board of small tokens into one massive, lethal threat."
  },
  {
    name: "Disturb",
    exampleCard: "Lunarch Veteran",
    description: "Written as 'Disturb [cost]'. You may cast this card transformed from your graveyard by paying its disturb cost.",
    notes: "If a card cast with Disturb would be put into a graveyard from anywhere, exile it instead."
  },
  {
    name: "Dredge",
    exampleCard: "Life from the Loam",
    description: "Written as 'Dredge X'. If you would draw a card, you may instead put the top X cards of your library into your graveyard and return the dredge card from your graveyard to your hand.",
    notes: "Widely regarded as broken because it turns the graveyard into a second hand and enables combos with cards like Prized Amalgam. It also fuels 'Delve' spells very efficiently."
  },
  {
    name: "Echo",
    exampleCard: "Avalanche Riders",
    description: "Written as 'Echo [cost]'. At the beginning of your next upkeep after this permanent comes under your control, sacrifice it unless you pay its echo cost.",
    notes: "An older mechanic often considered 'bad' by modern standards, as it forces you to pay for the creature twice just to keep it on the battlefield."
  },
  {
    name: "Devour",
    exampleCard: "Mycoloth",
    description: "As this enters the battlefield, you may sacrifice any number of creatures. This creature enters with X +1/+1 counters on it for each sacrificed creature, where X is the Devour number.",
    notes: "A powerful mechanic for 'Aristocrats' or token-heavy decks. It allows you to trade small, disposable creatures (like Saprolings or Goblins) to instantly create a massive, game-ending threat."
  },
  {
    name: "Echo",
    exampleCard: "Deranged Hermit",
    description: "At the beginning of your upkeep, if this permanent came under your control since the beginning of your last upkeep, sacrifice it unless you pay its echo cost.",
    notes: "A classic mechanic that allows you to deploy powerful, high-impact cards early in the game by splitting their total mana cost over two consecutive turns."
  },
  {
    name: "Embalm",
    exampleCard: "Aven Wind Guide",
    description: "Written as 'Embalm [cost]'. You may pay the cost to exile the card from your graveyard and create a token copy of it that is a white Zombie in addition to its other types.",
    notes: "Embalm can only be activated at sorcery speed. It's a great way to get a second use out of your creatures."
  },
  {
    name: "Emerge",
    exampleCard: "Elder Deep-Fiend",
    description: "You may cast this spell by sacrificing a creature and paying the emerge cost reduced by the sacrificed creature's mana value.",
    notes: "Similar to the 'Offering' mechanic, it allows you to cheat out massive Eldrazi by trading in a smaller creature."
  },
  {
    name: "Entwine",
    exampleCard: "Tooth and Nail",
    description: "Written as 'Entwine [cost]'. As you cast a spell with two choices, you may pay the entwine cost to choose both options instead of just one.",
    notes: "A staple for high-impact spells like Tooth and Nail, where choosing both options usually ends the game."
  },
  {
    name: "Epic",
    exampleCard: "Enduring Ideal",
    description: "For the rest of the game, you can't cast spells. At the beginning of each of your upkeeps, copy the Epic spell.",
    notes: "A high-risk, high-reward mechanic. It provides a massive benefit every turn but leaves you unable to interact with cards from your hand."
  },
  {
    name: "Escape",
    exampleCard: "Cling to Dust",
    description: "Written as 'Escape [cost]'. You may cast this card from your graveyard by paying its escape cost and exiling the required number of other cards from your graveyard.",
    notes: "Unlike Flashback, Escape cards can be cast multiple times as long as you have enough cards to exile."
  },
  {
    name: "Evoke",
    exampleCard: "Mulldrifter",
    description: "You may cast this spell for its evoke cost. If you do, it's sacrificed when it enters the battlefield.",
    notes: "Allows you to get the 'Enter the Battlefield' (ETB) trigger for a much lower mana cost. Interestingly, this mechanic is found almost exclusively on Elemental creatures."
  },
  {
    name: "Evolve",
    exampleCard: "Experiment One",
    description: "Whenever a creature enters the battlefield under your control with greater power or toughness than this creature, put a +1/+1 counter on this creature.",
    notes: "Example: Playing Experiment One on turn 1 followed by a 3/3 on turn 2 will trigger the evolve and buff your creature."
  },
  {
    name: "Exalted",
    exampleCard: "Noble Hierarch",
    description: "Whenever a creature you control attacks alone, that creature gets +1/+1 until end of turn.",
    notes: "Exalted abilities stack. If you have two creatures with Exalted and attack with only one, it gets +2/+2."
  },
  {
    name: "Exert",
    exampleCard: "Glorybringer",
    description: "As you attack, you may choose to exert the creature. If you do, it gains a special ability but won't untap during your next untap step.",
    notes: "A powerful way to push for an advantage, but it leaves you vulnerable for a turn while the creature 'recovers'."
  },
  {
    name: "Exploit",
    exampleCard: "Fell Stinger",
    description: "When this creature enters the battlefield, you may sacrifice a creature to trigger a special 'When [this] exploits a creature' ability.",
    notes: "You can even have the creature exploit itself if you just need the triggered effect immediately."
  },
  {
    name: "Explore",
    exampleCard: "Merfolk Branchwalker",
    description: "Reveal the top card of your library. If it's a land, put it into your hand. Otherwise, put a +1/+1 counter on this creature and then put the card back or into your graveyard.",
    notes: "If a card says 'Explore, explore' (like Jadelight Ranger), the process happens twice, allowing for up to two counters or two lands."
  },
  {
    name: "Extort",
    exampleCard: "Blind Obedience",
    description: "Whenever you cast a spell, you may pay {W/B}. If you do, each opponent loses 1 life and you gain that much life.",
    notes: "Commander Tip: Because the mana symbol is in the reminder text, Extort cards don't count toward the deck's color identity. You can play Blind Obedience in a mono-white or mono-black deck."
  },
  {
    name: "Fabricate",
    exampleCard: "Angel of Invention",
    description: "Written as 'Fabricate X'. When this creature enters, you may either put X +1/+1 counters on it or create X 1/1 colorless Servo artifact creature tokens.",
    notes: "Provides great flexibility: you can go 'tall' with one big creature or 'wide' with many small ones."
  },
  {
    name: "Fading",
    exampleCard: "Tangle Wire",
    description: "Written as 'Fading X'. This permanent enters with X fading counters. At the beginning of your upkeep, remove a counter or sacrifice it.",
    notes: "Fading is often confused with Vanishing. With Fading, you keep the permanent for one extra turn until you 'cannot' remove a counter during your upkeep."
  },
  {
    name: "Fateseal",
    exampleCard: "Spin into Myth",
    description: "To fateseal X, look at the top X cards of an opponent's library, then put any number of them on the bottom of that library and the rest on top in any order.",
    notes: "Essentially, it's 'Scrying' on your opponent's deck. It allows you to control their future draws, often ensuring they don't find the answers they need."
  },
  {
    name: "Fear",
    exampleCard: "Dross Prowler",
    description: "This creature cannot be blocked except by artifact creatures and/or black creatures.",
    notes: "Primarily found on older black cards. It was eventually replaced by 'Intimidate' and later 'Menace'."
  },
  {
    name: "Flanking",
    exampleCard: "Benalish Cavalry",
    description: "Whenever a creature without flanking blocks this creature, the blocking creature gets -1/-1 until end of turn.",
    notes: "An older, rare mechanic. It effectively makes the creature harder to block by smaller units, though it's less common in modern sets."
  },
  {
    name: "Flashback",
    exampleCard: "Faithless Looting",
    description: "Written as 'Flashback [cost]'. You may cast this card from your graveyard for its flashback cost. Then exile it.",
    notes: "This provides excellent card advantage by giving your spells a second life. It pairs perfectly with 'Dredge' or other self-mill strategies."
  },
  {
    name: "Flip",
    exampleCard: "Erayo, Soratami Ascendant",
    description: "Found on specific Kamigawa cards. If a condition is met, the card is rotated 180 degrees (upside-down) to reveal a new name, power/toughness, and abilities.",
    notes: "Not to be confused with 'Transforming' cards; flip cards stay on their front face but are rotated to show their evolved form."
  },
  {
    name: "Forecast",
    exampleCard: "Proclamation of Rebirth",
    description: "Written as 'Forecast [cost]'. During your upkeep, you may pay the cost and reveal this card from your hand to activate its forecast ability.",
    notes: "A great way to accrue value turn after turn without actually casting (and losing) the card from your hand."
  },
  {
    name: "Foretell",
    exampleCard: "Doomskar",
    description: "During your turn, you may pay {2} and exile this card face down. You may cast it on a later turn for its foretell cost.",
    notes: "This allows you to 'bank' spells for later. Note: You cannot cast a foretold card on the same turn you exile it."
  },
  {
    name: "Frenzy",
    exampleCard: "Frenzy Sliver",
    description: "Written as 'Frenzy X'. Whenever this creature attacks and isn't blocked, it gets +X/+0 until end of turn.",
    notes: "Currently found on only one card, Frenzy Sliver, making it one of the rarest mechanics in the game."
  },
  {
    name: "Graft",
    exampleCard: "Plaxcaster Frogling",
    description: "Written as 'Graft X'. This creature enters with X +1/+1 counters. Whenever another creature enters, you may move a +1/+1 counter from this creature to it.",
    notes: "Creatures with Graft are typically 0/0s that act as 'battery packs' for other creatures entering the battlefield."
  },
  {
    name: "Gravestorm",
    exampleCard: "Bitter Ordeal",
    description: "When you cast this spell, copy it for each permanent put into a graveyard from the battlefield this turn.",
    notes: "Similar to 'Storm', but counts permanents dying instead of spells being cast. Currently unique to the card Bitter Ordeal."
  },
  {
    name: "Haunt",
    exampleCard: "Belfry Spirit",
    description: "When this creature or spell is put into a graveyard, exile it haunting a creature. When the haunted creature dies, the haunt ability triggers.",
    notes: "Cards with haunt usually have an 'Enter the Battlefield' effect that is repeated later when the haunted creature dies."
  },
  {
    name: "Hideaway",
    exampleCard: "Mosswort Bridge",
    description: "When this enters, look at the top 4 cards of your library, exile one face down, then put the rest on the bottom. You may play the exiled card for free if a condition is met.",
    notes: "Most famous for the cycle of 5 Lorwyn lands (like Windbrisk Heights), which are staples in Commander for 'cheating' big spells into play."
  },
  {
    name: "Horsemanship",
    exampleCard: "Sun Quan, Lord of Wu",
    description: "This creature cannot be blocked except by creatures with horsemanship.",
    notes: "Essentially 'Flying' but from the Portal: Three Kingdoms set. It was designed for the Asian market to reflect the Three Kingdoms era. Because so few creatures have horsemanship, it's a very powerful form of evasion today."
  },
  {
    name: "Imprint",
    exampleCard: "Isochron Scepter",
    description: "Written as 'Imprint [quality]'. When this permanent enters the battlefield, you may exile a card to grant this permanent a new ability based on the exiled card.",
    notes: "Isochron Scepter and Mimic Vat are among the most popular imprint cards in Commander, allowing players to reuse powerful spells every turn."
  },
  {
    name: "Indestructible",
    exampleCard: "Avacyn, Angel of Hope",
    description: "A permanent with indestructible cannot be destroyed by 'destroy' effects or by lethal damage.",
    notes: "Indestructible does not protect against: 1) Exile effects (Swords to Plowshares), 2) Being tucked or bounced (Cyclonic Rift), or 3) Having 0 or less toughness (Toxic Deluge). Interesting interaction: If an indestructible creature takes lethal damage first, then receives enough -1/-1 counters to reduce its toughness below 0, it will die."
  },
  {
    name: "Inspired",
    exampleCard: "King Macar, the Gold-Cursed",
    description: "An ability that triggers whenever the creature becomes untapped.",
    notes: "This encourages finding ways to tap your own creatures (like attacking or using them for 'Convoke') to set up the untap trigger."
  },
  {
    name: "Investigate",
    exampleCard: "Thraben Inspector",
    description: "To investigate, create a Clue token. A Clue is a colorless artifact with '{2}, Sacrifice this artifact: Draw a card.'",
    notes: "Investigate is a great way to 'bank' card draw for later in the game."
  },
  {
    name: "Jump-start",
    exampleCard: "Radical Idea",
    description: "You may cast this card from your graveyard by paying its mana cost and discarding a card as an additional cost. Then exile this card.",
    notes: "Similar to Flashback, but it requires a discard, making it useful for filling the graveyard with other synergies."
  },
  {
    name: "Kicker",
    exampleCard: "Tourach, Dread Cantor",
    description: "An optional additional cost you may pay as you cast a spell for an added effect.",
    notes: "In the Magic community, it's a common joke that 'every mechanic is just a variant of Kicker or Flashback.' Multikicker is a variant where you can pay the kicker cost any number of times for stacking effects."
  },
  {
    name: "Level Up",
    exampleCard: "Lighthouse Chronologist",
    description: "Written as 'Level up [cost]'. At sorcery speed, you may pay the cost to put a level counter on the creature. As it reaches certain levels, it gains new stats and abilities.",
    notes: "You can level up as many times as you want per turn, provided you have the mana."
  },
  {
    name: "Landwalk",
    exampleCard: "Benthic Behemoth",
    description: "Written as '[Land Type]walk'. This creature cannot be blocked if the defending player controls at least one land of the specified type.",
    notes: "Even if the blocker also has landwalk, it still cannot block an attacking landwalker. It's a binary form of evasion."
  },
  {
    name: "Living Weapon",
    exampleCard: "Batterskull",
    description: "When this Equipment enters, create a 0/0 black Germ creature token and attach this to it.",
    notes: "The equipment provides the toughness needed for the Germ to stay alive. If the equipment is unattached, the Germ usually dies instantly as its toughness returns to 0."
  },
  {
    name: "Madness",
    exampleCard: "Basking Rootwalla",
    description: "If you discard this card, you may cast it for its madness cost instead of putting it into your graveyard.",
    notes: "Madness allows you to turn a 'downside' (discarding) into a powerful advantage, often letting you cast spells at instant speed or for much less mana."
  },
  {
    name: "Manifest",
    exampleCard: "Reality Shift",
    description: "To manifest a card, put it onto the battlefield face down as a 2/2 creature. You can turn it face up any time for its mana cost.",
    notes: "If you manifest a creature with Morph, you can use either its mana cost or its morph cost to turn it face up."
  },
  {
    name: "Mentor",
    exampleCard: "Legion Warboss",
    description: "Whenever this creature attacks, put a +1/+1 counter on target attacking creature with less power than this creature.",
    notes: "The trigger happens during the declaration of attackers. If a creature is put onto the battlefield already attacking, Mentor will not trigger."
  },
  {
    name: "Miracle",
    exampleCard: "Temporal Mastery",
    description: "You may cast this card for its miracle cost if it's the first card you've drawn this turn and you reveal it immediately.",
    notes: "Miracles can be cast at any time you draw them (even on an opponent's turn), effectively ignoring the usual timing restrictions for sorceries."
  },
  {
    name: "Modular",
    exampleCard: "Arcbound Mouser",
    description: "Written as 'Modular X'. This creature enters with X +1/+1 counters. When it dies, you may put its +1/+1 counters on target artifact creature.",
    notes: "A core mechanic for artifact 'Aristocrats' decks, ensuring that your power stays on the board even after a creature dies."
  },
  {
    name: "Monstrosity",
    exampleCard: "Fleecemane Lion",
    description: "Written as '[cost]: Monstrosity X'. If this creature isn't monstrous, pay the cost to put X +1/+1 counters on it and it becomes monstrous.",
    notes: "You can activate monstrosity in response to removal. For example, making Fleecemane Lion monstrous in response to a destroy spell will give it hexproof and indestructible, saving it."
  },
  {
    name: "Morph / Megamorph",
    exampleCard: "Ainok Survivalist",
    description: "You may cast this card face down as a 2/2 creature for {3}. You can turn it face up any time for its morph cost.",
    notes: "Turning a card face up is a 'Special Action' that doesn't use the stack and cannot be responded to. Megamorph is identical but adds a +1/+1 counter upon flipping."
  },
  {
    name: "Mutate",
    exampleCard: "Dirge Bat",
    description: "You may cast this spell for its mutate cost over or under a non-human creature you control. They merge into one creature with all the abilities of every card in the 'pile'.",
    notes: "The top card determines the power and toughness. If the target creature is removed in response to the mutate spell, the mutating creature still enters the battlefield as a normal creature."
  },
  {
    name: "Ninjutsu",
    exampleCard: "Ninja of the Deep Hours",
    description: "Written as 'Ninjutsu [cost]'. You may return an unblocked attacking creature you control to its owner's hand and put this card onto the battlefield from your hand tapped and attacking.",
    notes: "Ninjutsu is an activated ability, not a spell, so it cannot be countered by traditional Counterspells. However, cards like Containment Priest can stop it. It's perfect for triggering 'deals combat damage' abilities."
  },
  {
    name: "Offering",
    exampleCard: "Patron of the Kitsune",
    description: "Written as '[Type] offering'. You may cast this spell as though it had flash by sacrificing a creature of the specified type and paying the difference in mana costs.",
    notes: "Example: If you sacrifice a snake that costs {2}{G} to cast a Patron of the Orochi ({6}{G}{G}), you only need to pay {4}{G}. You essentially subtract the sacrificed creature's cost from the total."
  },
  {
    name: "Overload",
    exampleCard: "Vandalblast",
    description: "Written as 'Overload [cost]'. You may cast this spell for its overload cost. If you do, replace every instance of 'target' in the spell's text with 'each'.",
    notes: "A powerful way to turn a single-target removal into a board wipe. Vandalblast, for instance, goes from destroying one artifact to destroying every artifact your opponents control."
  },
  {
    name: "Persist",
    exampleCard: "Kitchen Finks",
    description: "When this creature dies, if it had no -1/-1 counters on it, return it to the battlefield with a -1/-1 counter.",
    notes: "A very combo-friendly mechanic. It effectively doubles the value of 'Enter the Battlefield' or death triggers. If you can remove the -1/-1 counter, the creature can persist indefinitely."
  },
  {
    name: "Phasing",
    exampleCard: "Sandbar Crocodile",
    description: "Phased-out permanents are treated as though they don't exist. They phase in (return) or phase out at the beginning of their controller's upkeep.",
    notes: "Unlike exile, phasing doesn't trigger 'Leave the Battlefield' or 'Enter the Battlefield' effects. Auras and Equipment attached to the creature phase out and in with it."
  },
  {
    name: "Poisonous / Infect",
    exampleCard: "Virulent Sliver / Glistener Elf",
    description: "Poisonous X: Whenever this deals combat damage to a player, they get X poison counters. Infect: Deals damage to players in poison counters and to creatures in -1/-1 counters.",
    notes: "A player with 10 poison counters loses the game. Poisonous has mostly been replaced by Infect, which scales with the creature's power (Infect deals poison counters equal to its power, while Poisonous is always a fixed number)."
  },
  {
    name: "Populate",
    exampleCard: "Growing Ranks",
    description: "Create a creature token that is a copy of a creature token you already control.",
    notes: "A staple for Selesnya (Green/White) decks that focus on making large, powerful tokens."
  },
  {
    name: "Proliferate",
    exampleCard: "Grateful Apparition",
    description: "To proliferate, choose any number of players and/or permanents that have a counter and add another counter of a kind already there.",
    notes: "Works on everything: +1/+1 counters, loyalty counters on Planeswalkers, and even poison counters on players. You cannot add a counter to something that doesn't already have one."
  },
  {
    name: "Provoke",
    exampleCard: "Lowland Tracker",
    description: "When this creature attacks, you may have target creature defending player controls untap and block it if able.",
    notes: "Generally considered a weak mechanic, but useful for forcing a utility creature (like a mana dork) into a fight it will lose."
  },
  {
    name: "Prowl",
    exampleCard: "Latchkey Faerie",
    description: "Written as 'Prowl [cost]'. You may cast this for its prowl cost if you dealt combat damage to a player this turn with a creature that shares a type with this card.",
    notes: "Commonly found in Rogue decks, allowing for cheaper casting costs and additional effects."
  },
  {
    name: "Rampage",
    exampleCard: "Craw Giant",
    description: "Written as 'Rampage X'. For each creature beyond the first assigned to block this creature, it gets +X/+X until end of turn.",
    notes: "An old-school mechanic designed to punish opponents for multi-blocking a single large threat."
  },
  {
    name: "Rebound",
    exampleCard: "Ephemerate",
    description: "If you cast this spell from your hand, exile it as it resolves. At the beginning of your next upkeep, you may cast it from exile without paying its mana cost.",
    notes: "Provides 'double' value for your instants and sorceries. Ephemerate is a standout example in modern play."
  },
  {
    name: "Recover",
    exampleCard: "Icefall",
    description: "Written as 'Recover [cost]'. When a creature is put into your graveyard from the battlefield, you may pay the recover cost to return this card from your graveyard to your hand. If you don't, exile it.",
    notes: "A 'use it or lose it' mechanic. You must have the mana ready when the trigger happens, or the card is gone forever."
  },
  {
    name: "Reinforce",
    exampleCard: "Burrenton Bombardier",
    description: "Written as 'Reinforce X—[cost]'. You may pay the cost and discard this card to put X +1/+1 counters on target creature.",
    notes: "Essentially a 'combat trick' that you can use from your hand, making it harder to counter than a standard spell."
  },
  {
    name: "Renown",
    exampleCard: "Scab-Clan Berserker",
    description: "Written as 'Renown X'. When this creature deals combat damage to a player for the first time, if it isn't renowned, put X +1/+1 counters on it and it becomes renowned.",
    notes: "Many creatures gain secondary, powerful abilities once they have achieved 'Renown' status."
  },
  {
    name: "Replicate",
    exampleCard: "Shattering Spree",
    description: "Written as 'Replicate [cost]'. When you cast this spell, you may pay the replicate cost any number of times. Copy the spell for each time the cost was paid.",
    notes: "Great for getting around single counterspells, as the opponent would need to counter every copy individually."
  },
  {
    name: "Retrace",
    exampleCard: "Oona’s Grace",
    description: "You may cast this card from your graveyard by discarding a land card in addition to paying its other costs.",
    notes: "Unlike Flashback, Retrace cards are not exiled. As long as you have lands to discard, you can keep casting the spell."
  },
  {
    name: "Riot",
    exampleCard: "Gruul Spellbreaker",
    description: "This creature enters the battlefield with your choice of a +1/+1 counter or haste.",
    notes: "Provides flexibility: choose Haste for immediate pressure or the +1/+1 counter for a better long-term presence."
  },
  {
    name: "Ripple",
    exampleCard: "Surging Dementia",
    description: "Written as 'Ripple X'. When you cast this spell, you may reveal the top X cards of your library and cast any with the same name for free.",
    notes: "Generally considered a weak mechanic unless paired with Thrumming Stone and a deck full of identical cards (like Relentless Rats or Dragon's Approach)."
  },
  {
    name: "Scavenge",
    exampleCard: "Deadbridge Goliath",
    description: "Written as 'Scavenge [cost]'. Exile this card from your graveyard and pay its scavenge cost: Put a number of +1/+1 counters equal to this card's power onto target creature.",
    notes: "Scavenge can only be activated at sorcery speed. It's a great way to use 'dead' creatures in your graveyard to buff your board."
  },
  {
    name: "Shadow",
    exampleCard: "Dauthi Cutthroat",
    description: "Creatures with shadow can only block or be blocked by other creatures with shadow.",
    notes: "A powerful but 'binary' form of evasion. If your opponent doesn't have shadow creatures, they simply cannot block yours, and vice-versa."
  },
  {
    name: "Shroud",
    exampleCard: "Argothian Enchantress",
    description: "A permanent with shroud cannot be the target of spells or abilities (even yours).",
    notes: "Unlike Hexproof, Shroud is 'fair' because even you cannot target your own creature with auras or combat tricks."
  },
  {
    name: "Soulbond",
    exampleCard: "Deadeye Navigator",
    description: "You may pair this creature with another unpaired creature when either enters the battlefield. They remain paired for as long as you control both.",
    notes: "Deadeye Navigator is the most famous example, allowing for infinite 'flicker' combos if you have enough mana."
  },
  {
    name: "Soulshift",
    exampleCard: "Elder Pine of Jukai",
    description: "Written as 'Soulshift X'. When this creature dies, you may return a Spirit card with mana value X or less from your graveyard to your hand.",
    notes: "A signature mechanic of the original Kamigawa spirits, providing a constant chain of recursion."
  },
  {
    name: "Spectacle",
    exampleCard: "Light up the Stage",
    description: "Written as 'Spectacle [cost]'. You may cast this spell for its spectacle cost if an opponent lost life this turn.",
    notes: "This includes damage but also direct life loss. It often makes powerful spells significantly cheaper."
  },
  {
    name: "Splice",
    exampleCard: "Everdream",
    description: "Written as 'Splice onto [type] [cost]'. As you cast a spell of the specified type, you may reveal this card and pay its splice cost to add its effect to that spell.",
    notes: "The Splice card stays in your hand, allowing you to repeatedly 'tack on' its effect to multiple spells over several turns."
  },
  {
    name: "Split Second",
    exampleCard: "Angel’s Grace",
    description: "As long as this spell is on the stack, players can't cast spells or activate abilities that aren't mana abilities.",
    notes: "Basically, the spell cannot be interacted with. It's the ultimate 'no' to your opponent's planned responses."
  },
  {
    name: "Storm",
    exampleCard: "Grapeshot",
    description: "When you cast this spell, copy it for each spell cast before it this turn.",
    notes: "Famously 'broken'. If you cast 2 spells then a Grapeshot, you get the original plus 2 copies (3 total). It's the basis for entire combo decks."
  },
  {
    name: "Sunburst",
    exampleCard: "Engineered Explosives",
    description: "This enters the battlefield with a +1/+1 counter (for creatures) or a charge counter (for non-creatures) for each color of mana spent to cast it.",
    notes: "It rewards five-color decks. If you spend {W}{U}{B} on a {5} cost card, it only gets 3 counters."
  },
  {
    name: "Support",
    exampleCard: "Generous Patron",
    description: "Written as 'Support X'. Put a +1/+1 counter on each of up to X target creatures.",
    notes: "You can target your own creatures or an opponent's (which is useful for cards like Generous Patron that trigger when you buff others' things)."
  },
  {
    name: "Surveil",
    exampleCard: "Notion Rain",
    description: "To surveil X, look at the top X cards of your library, then put any number of them into your graveyard and the rest on top in any order.",
    notes: "Similar to Scry, but puts cards in the graveyard instead of the bottom of the deck. This is often better as it fuels graveyard synergies."
  },
  {
    name: "Suspend",
    exampleCard: "Rift Bolt",
    description: "Written as 'Suspend X—[cost]'. Rather than cast this from your hand, pay the cost and exile it with X time counters. Remove one each upkeep; when the last is gone, cast it for free with haste.",
    notes: "If a card only has a suspend cost (like Ancestral Vision), you must suspend it to cast it normally."
  },
  {
    name: "Totem Armor",
    exampleCard: "Bear Umbra",
    description: "If the enchanted creature would be destroyed, instead remove all damage from it and destroy this Aura.",
    notes: "A powerful protection for Auras. If you have multiple Umbras, you choose which one breaks to save the creature."
  },
  {
    name: "Transfigure",
    exampleCard: "Fleshwrither",
    description: "Written as '[cost], Sacrifice this: Search your library for a creature card with the same mana value as this and put it into play. Activate only as a sorcery.'",
    notes: "Found only on Fleshwrither. It's like 'Transmute' but from the battlefield instead of the hand."
  },
  {
    name: "Transform",
    exampleCard: "Aberrant Researcher",
    description: "Applies to double-faced cards. When a condition is met, the card flips over to its back side, often becoming much stronger.",
    notes: "The back side doesn't have a mana cost, but its 'color identity' is usually determined by a circle on the type line."
  },
  {
    name: "Transmute",
    exampleCard: "Muddle the Mixture",
    description: "Written as 'Transmute [cost]'. Discard this card and pay the cost: Search your library for a card with the same mana value, reveal it, and put it into your hand. Activate only as a sorcery.",
    notes: "An incredible tutor mechanic for finding specific combo pieces (like a 2-mana counterspell searching for a 2-mana win-con)."
  },
  {
    name: "Undying",
    exampleCard: "Young Wolf",
    description: "When this creature dies, if it had no +1/+1 counters on it, return it to the battlefield with a +1/+1 counter.",
    notes: "It's 'Persist' but with a buff. If you can remove the +1/+1 counter, the creature will keep coming back forever."
  },
  {
    name: "Unearth",
    exampleCard: "Dregscape Zombie",
    description: "Written as 'Unearth [cost]'. Return this card from your graveyard to the battlefield. It gains haste. Exile it at the beginning of the next end step or if it would leave the battlefield. Activate only as a sorcery.",
    notes: "A one-time 'reanimation' that is great for final aggressive pushes."
  },
  {
    name: "Unleash",
    exampleCard: "Rakdos Cackler",
    description: "You may have this creature enter the battlefield with a +1/+1 counter on it. It can't block as long as it has a +1/+1 counter on it.",
    notes: "The 'can't block' restriction applies regardless of where the +1/+1 counter came from."
  },
  {
    name: "Wither",
    exampleCard: "Harvest Gwyllion",
    description: "This creature deals damage to creatures in the form of -1/-1 counters.",
    notes: "Unlike Infect, Wither still deals normal damage to players, but it permanently weakens any creature it fights."
  },
  {
    name: "Addendum / Battalion / Chroma / Domain",
    exampleCard: "Various",
    description: "Ability words that check for conditions: Addendum (Main phase bonus), Battalion (3+ attackers), Chroma (Mana symbol count), Domain (Basic land types).",
    notes: "These aren't keywords with rules themselves, but headers for specific themed abilities."
  },
  {
    name: "Hellbent / Heroic / Landfall",
    exampleCard: "Various",
    description: "Hellbent (No cards in hand), Heroic (Targeted by your spell), Landfall (Land enters battlefield).",
    notes: "Hellbent only checks upon resolution; if you empty your hand while the spell is on the stack, it works!"
  },
  {
    name: "Metalcraft / Morbid / Raid / Threshold",
    exampleCard: "Various",
    description: "Metalcraft (3+ Artifacts), Morbid (Something died this turn), Raid (You attacked this turn), Threshold (7+ cards in graveyard).",
    notes: "Classic ability words that track the state of the game to provide powerful bonuses."
  },
  {
    name: "Undergrowth",
    exampleCard: "Kraul Foragers",
    description: "An ability word that triggers or scales based on the number of creature cards in your graveyard.",
    notes: "The more creatures you've lost, the stronger these effects become. Signature of the Golgari (Black/Green) swarm."
  }
];